// ORDERS
const SET_ORDERS = 'SET_ORDERS';
const LOADING_COUNT = 'LOADING_COUNT';
const SET_ORDER_COUNT = 'SET_ORDER_COUNT';
const SET_TOTAL_SALES = 'SET_TOTAL_SALES';
const SET_SELECTED_ORDER = 'SET_SELECTED_ORDER';
const LOADING_ORDERS = 'LOADING_ORDERS';
const SET_ORDER_ERROR = 'SET_ORDER_ERROR';
const SET_ORDER_REPORT_STATUS = 'SET_ORDER_REPORT_STATUS';

export {
  SET_ORDERS,
  LOADING_COUNT,
  SET_ORDER_COUNT,
  SET_TOTAL_SALES,
  SET_SELECTED_ORDER,
  LOADING_ORDERS,
  SET_ORDER_ERROR,
  SET_ORDER_REPORT_STATUS,
};
